// extracted by mini-css-extract-plugin
export var active = "_ml-2";
export var recordingDot = "_ml-1";
export var recordingIndicator = "_ml-0";